import { useEffect, useRef } from 'react';

// Report the current value. Two effects, not one with a cleanup: a single
// effect whose cleanup emits `false` would fire `false` then `true` on
// every dependency change (batched, harmless, but publishes an
// intermediate state nobody wants). Split, this effect is monotone in the
// value and the retraction effect below runs exactly once.
export function useRegistrationDateBlockedSignal(
    registrationDateBlocked: boolean,
    onRegistrationDateBlockedChange?: (blocked: boolean) => void,
): void {
    useEffect(() => {
        onRegistrationDateBlockedChange?.(registrationDateBlocked);
    }, [registrationDateBlocked, onRegistrationDateBlockedChange]);

    // Retract on unmount, and ONLY on unmount. D4: the flag must never outlive
    // this form. Read through a ref so the mount-scoped effect cannot capture
    // a stale callback — the same ref-mirror shape the form-state hook
    // (`useAdditionalVehicleDetailsFormState.ts`) uses for `dirtyRef`/`vehicleIdentityRef`.
    const reportBlockedRef = useRef(onRegistrationDateBlockedChange);
    reportBlockedRef.current = onRegistrationDateBlockedChange;
    useEffect(() => {
        return () => reportBlockedRef.current?.(false);
    }, []);
}
